var _effectorFileName = "/builds/gmini/front-ui-kit/src/NotifyButton/NotifyButton.tsx";
import { Notify } from '../icons';
import { Inner, Dot, Button } from './NotifyButton.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NotifyButton = ({
  onClick,
  active,
  ...other
}) => /*#__PURE__*/_jsx(Button, {
  onClick: onClick,
  ...other,
  children: /*#__PURE__*/_jsxs(Inner, {
    children: [/*#__PURE__*/_jsx(Notify, {
      color: active ? 'rgb(53, 59, 96)' : 'rgba(53, 59, 96, 0.5)'
    }), active && /*#__PURE__*/_jsx(Dot, {})]
  })
});